<template>
  <div class="container d-flex justify-content-center">
    <TheScreen />
  </div>
</template>

<script>
import TheScreen from "./screens/TheScreen";

export default {
  name: "App",
  components: {
    TheScreen,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
